import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/home/home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/news",
    name: "news-list",
    component: () => import("../pages/news/news.vue"),
  },
  {
    path: "/news/:id",
    name: "news-detail",
    component: () => import("../pages/news/article.vue"),
  },
  {
    path: "/research",
    name: "research",
    component: () => import("../pages/research/research.vue"),
  },
  {
    path: "/videos",
    name: "videos",
    component: () => import("../pages/videos/videos.vue"),
  },
  {
    path: "/videos/:id",
    name: "videos-detail",
    component: () => import("../pages/videos/detail.vue"),
  },
  {
    path: "/research/:id",
    name: "research-detail",
    component: () => import("../pages/news/article.vue"),
  },
  {
    path: "/events",
    name: "events",
    component: () => import("../pages/events/events.vue"),
  },
  {
    path: "/events/:id",
    name: "events-detail",
    component: () => import("../pages/news/article.vue"),
  },
  {
    path: "/partnership",
    name: "partnership",
    component: () => import("../pages/partnership/partnership.vue"),
  },
  {
    path: "/about-us",
    name: "about",
    component: () => import("../pages/about-us/about.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../pages/contact/contact.vue"),
  },
  {
    path: "*",
    name: "404",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
